export const getEndDate = (endDateArg) => {
  return endDateArg;
};

export const getEndDateWithTimezoneOffset = (endDateArg, isSBOTD) => {
  if (!isSBOTD) {
    return endDateArg;
  }
  // added a timezone offset to the time used for the countdown
  // for SBOTD deals
  // without the offset, the the countdown timer displays the wrong time.

  // offset in milliseconds
  const tzoffset = (new Date()).getTimezoneOffset() * 60000;
  const currentTimeMinusOffset = Date.now() - tzoffset;
  const endDate = new Date(currentTimeMinusOffset);
  const todaysDateWithTimezone = (endDate).toISOString().split('T')[0];

  return todaysDateWithTimezone;

};